import { QuestionComponentProps } from "..";

import { PositiveTechnologiesSelector } from "./components/PositiveTechnologiesSelector";

export function PositiveTechnologies({
  setNextEnabled,
}: QuestionComponentProps): React.ReactElement {
  return (
    <PositiveTechnologiesSelector
      onPreferenceSet={(isPreferenceSet: boolean) =>
        setNextEnabled?.(isPreferenceSet)
      }
    />
  );
}
